<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main.vue'
import address from 'address'

export default {
  page: {
    title: 'Home',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      error: '',
      input: '',
      ztxAddress: null,
      txHash: null,
      createdDate: null,
      timePassed: null,
      loading: false,
      // turnstileSiteKey: process.env.VUE_APP_TURNSTILE_SITE_KEY,
      // turnstileToken: '',
      // turnstileWidgetId: null,
      // turnstileInitTimer: null,
      // turnstileInitAttempts: 0,
    }
  },
  computed: {
    address() {
      return address
    },
    placeholders() {
      return {
        ztxAddress: 'Enter your wallet address (ZTX3..)',
      }
    },
  },
  async mounted() {
    this.getHistory()
    // this.initTurnstile()
  },
  // beforeDestroy() {
  //   if (this.turnstileInitTimer) {
  //     clearTimeout(this.turnstileInitTimer)
  //   }
  //   if (window.turnstile && this.turnstileWidgetId !== null) {
  //     window.turnstile.remove(this.turnstileWidgetId)
  //   }
  // },
  methods: {
    getHistory() {
      // console.log("Get History")
      this.$store.dispatch('faucet/fetchHistory').then((response) => {
        // console.log(response);
        if (response != null) {
          this.ztxAddress = response.address
          this.txHash = response.txHash
          this.createdDate = new Date(response.createdAt)

          this.updateTime()
        }
        this.loading = false
      })
    },
    updateTime() {
      if (this.createdDate === null) return

      if (this.t) {
        clearInterval(this.t)
      }

      const today = new Date()
      const hours = parseInt(
        (Math.abs(today - this.createdDate) / (1000 * 60 * 60)) % 24
      )
      const minutes = parseInt(
        (Math.abs(today.getTime() - this.createdDate.getTime()) / (1000 * 60)) %
          60
      )
      if (hours > 0) {
        this.timePassed = `${hours} hour ${minutes} min ago`
      } else {
        this.timePassed = `${minutes} min ago`
      }

      this.t = setInterval(() => {
        this.updateTime()
      }, 60 * 1000)
    },
    // initTurnstile() {
    //   if (!this.turnstileSiteKey) {
    //     this.error = 'Turnstile site key is missing.'
    //     return
    //   }

    //   if (window.turnstile && window.turnstile.render) {
    //     this.renderTurnstile()
    //     return
    //   }

    //   this.turnstileInitAttempts += 1
    //   if (this.turnstileInitAttempts > 20) {
    //     this.error = 'Turnstile failed to load. Please refresh and try again.'
    //     return
    //   }

    //   this.turnstileInitTimer = setTimeout(() => {
    //     this.initTurnstile()
    //   }, 250)
    // },
    // renderTurnstile() {
    //   const container = this.$refs.turnstileContainer
    //   if (!container) return

    //   if (this.turnstileWidgetId !== null) {
    //     window.turnstile.reset(this.turnstileWidgetId)
    //     return
    //   }

    //   this.turnstileWidgetId = window.turnstile.render(container, {
    //     sitekey: this.turnstileSiteKey,
    //     callback: this.onTurnstileSuccess,
    //     'expired-callback': this.onTurnstileExpired,
    //     'error-callback': this.onTurnstileError,
    //   })
    // },
    // onTurnstileSuccess(token) {
    //   // console.log("Turnstile token received:", token)
    //   this.turnstileToken = token
    // },
    // onTurnstileExpired() {
    //   this.turnstileToken = ''
    // },
    // onTurnstileError() {
    //   this.turnstileToken = ''
    //   this.error = 'Turnstile verification failed. Please try again.'
    // },
    // resetTurnstile() {
    //   if (window.turnstile && this.turnstileWidgetId !== null) {
    //     window.turnstile.reset(this.turnstileWidgetId)
    //   }
    //   this.turnstileToken = ''
    // },
    async submit(address) {
      // console.log("Submit", address)
      this.error = ''
      this.loading = true

      // if (!this.turnstileToken) {
      //   this.error = 'Please complete the verification.'
      //   this.loading = false
      //   return
      // }

      this.$store
        .dispatch('faucet/requestFaucet', {
          address: address,
        })
        .then((response) => {
          // console.log(response);
          if (response.object !== null) {
            this.getHistory()
            this.input = ''
          } else {
            this.error = response.messages[0].message
            this.loading = false
          }
        })
    },
    openUrl(hash) {
      if (hash == null) return
      const url = 'https://test-explorer.zetrix.com/tx/' + hash
      window.open(url, '_blank')
    },
  },
}
</script>

<template>
  <Layout>
    <div :class="$style['ztx-label']">Zetrix Faucet</div>
    <div :class="$style['ztx-description']">Fast and reliable. 1 ZTX/day</div>
    <div v-if="error.length > 0" :class="$style['faucet-error']">
      {{ error }}
    </div>
    <div :class="$style['faucet-wallet']">
      <div :class="$style['faucet-wallet-label']">Zetrix Wallet</div>
      <div :class="$style['faucet-wallet-wrapper']">
        <div :class="$style['faucet-wallet-input']">
          <BaseInputText
            v-model="input"
            name="input"
            type="text"
            :placeholder="placeholders.ztxAddress"
          />
        </div>
        <div :class="$style['faucet-wallet-button']">
          <BaseButton
            :disabled="input.length !== 37 || input.substring(0, 4) !== 'ZTX3'"
            type="submit"
            @click="submit(input)"
            >Give me ZTX!
          </BaseButton>
        </div>
      </div>
      <!-- <div :class="$style['faucet-turnstile']">
        <div ref="turnstileContainer"></div>
      </div> -->
    </div>
    <div :class="$style['faucet-history']">
      <div :class="$style['faucet-history-label-wrapper']">
        <div :class="$style['faucet-history-label']">Your Transaction</div>
        <div v-if="loading" :class="$style['faucet-history-anim']">
          <BaseDotsAnim></BaseDotsAnim>
        </div>
      </div>
      <div :class="$style['faucet-history-content']">
        <div :class="$style['faucet-history-address']">
          <span v-if="ztxAddress !== null">
            {{ ztxAddress }}
          </span>
          <span v-else> - </span>
        </div>
        <div :class="$style['faucet-history-hash']" @click="openUrl(txHash)">
          <span
            v-if="ztxAddress !== null && txHash !== null"
            :class="$style['faucet-history-hash-1']"
          >
            {{ txHash.substring(0, 6) }}...{{
              txHash.substring(txHash.length - 5, txHash.length)
            }}
          </span>
          <span
            v-if="ztxAddress !== null && txHash === null"
            :class="$style['faucet-history-hash-2']"
          >
            Pending verification
          </span>
        </div>
        <div :class="$style['faucet-history-time']">
          <span v-if="ztxAddress !== null && timePassed !== null">
            {{ timePassed }}
          </span>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

/* stylelint-disable */
.ztx-label {
  color: $color-main-theme;
  font: normal normal bold 40px/60px Poppins;
  font-size: 40px;
  text-align: center;
  margin-top: 40px;
  margin-bottom: 20px;
}

.ztx-description {
  color: black;
  font: normal normal normal 16px/25px Poppins;
  font-size: 16px;
  text-align: center;
  margin-bottom: 20px;
}

.faucet-wallet {
  padding: 20px 20px 1px 20px;
  background-color: white;
  border-radius: $size-input-border-radius;
  margin-bottom: 20px;
}

.faucet-wallet-label {
  font: normal normal normal 16px/25px Poppins;
  font-size: 16px;
  margin-bottom: 8px;
}

.faucet-history-anim {
  margin-top: 16px;
  margin-left: 25px;
}

.faucet-wallet-wrapper {
  display: flex;
  flex-direction: row;
}

// .faucet-turnstile {
//   display: flex;
//   justify-content: flex-start;
//   margin: 12px 0 6px 0;
// }

.faucet-wallet-input {
  flex-grow: 1;
  padding-right: 20px;
}

.faucet-wallet-button {
  width: 174px;
}

.faucet-history {
  padding: 20px 20px 1px 20px;
  background-color: white;
  border-radius: $size-input-border-radius;
  margin-bottom: 32px;
}

.faucet-history-label {
  font: normal normal bold 24px/35px Poppins;
  font-size: 24px;
  margin-bottom: 8px;
}

.faucet-history-label-wrapper {
  display: flex;
  flex-direction: row;
}

.faucet-history-content {
  font: normal normal normal 16px/25px Poppins;
  font-size: 16px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  color: black;
}

.faucet-history-address {
  font: normal normal bold 16px/25px Poppins;
  font-size: 16px;
  margin-right: 50px;
}

.faucet-history-hash {
  font: normal normal normal 16px/25px Poppins;
  font-size: 16px;
  margin-right: 50px;
}

.faucet-history-time {
  font: normal normal normal 16px/25px Poppins;
  font-size: 14px;
}

.faucet-error {
  background: #f27676 0% 0% no-repeat padding-box;
  height: 55px;
  text-align: center;
  color: white;
  padding-top: 18px;
  font-size: 16px;
  margin-bottom: 32px;
}

.faucet-history-hash-1 {
  text-decoration: underline;
  cursor: pointer;
}

.faucet-history-hash-2 {
  color: gray;
}

@media screen and (max-width: 1000px) {
  .faucet-wallet-wrapper {
    display: flex;
    flex-direction: column;
  }

  .faucet-wallet-input {
    flex-grow: 1;
    padding-right: 0;
  }

  .faucet-wallet-button {
    flex-grow: 1;
    width: 100%;
    margin-bottom: 20px;
  }

  .faucet-history-content {
    flex-direction: column;
  }

  .faucet-history-address {
    font-size: 14px;
    margin-right: 0;
    text-align: center;
  }

  .faucet-history-hash {
    margin-right: 0;
    text-align: center;
  }

  .faucet-history-time {
    text-align: center;
  }
}
</style>
